/**
 * Defines the route path for each page.
 */
export const homeRoute = '/';
export const appRoute = '/app';
export const benefitsRoute = '/benefits';
export const registerRoute = '/contribute';
export const eightOneOneRoute = '/811';
export const eooDamageReportingRoute = '/damage-reporting';
export const factsAndStatsRoute = '/facts-and-stats';
export const goalsRoute = '/goals';
export const lawRoute = '/state/:state/law/:lawId';
export const leakRecognitionRoute = '/leak-recognition';
export const markersRoute = '/markers';
export const preventionMeasuresRoute = '/prevention-measures';
export const privacyPolicy = '/privacy-policy';
export const termsAndConditions = '/terms-and-conditions';
export const resourcesRoute = '/resources';
export const responseRoute = '/leak-response';
export const sponsorshipOptionsRoute = '/sponsorship-options';
export const statesRoute = '/states';
export const stateRoute = '/state/:state';
export const stateChecklistRoute = '/state/:state/checklist';
export const stateLawRoute = '/states/:state/law';
export const stateLocateRequestRoute = '/state/:state/locate';
export const stateResourceRoute = '/state/:state/resources/:resourceId';
export const stateResourcesRoute = '/state/:state/resources';
export const supportingCompaniesRoute = '/supporting-companies';
export const ugiCommunicationsRoute = '/communications';
export const ugiElectricityRoute = '/electric';
export const ugiPipelinesRoute = '/pipelines';
export const ugiWaterSewerRoute = '/water-sewer';
export const undergroundInfrastructureRoute = '/underground-infrastructure';
export const video811 = '/811videoa1b2c3';
export const videoTeaser = '/teaser';
export const videoPageRoute = '/:companyName';
export const baseVideoPageRoute = '/meet-the-experts';
export const psaPageRoute='/psa';
export const safeDigging = '/safe-digging-checklist';





// WEBPACK FOOTER //
// ./src/components/routePaths.js